export const SocketEventName = {
  send_message_chat_ai: 'send-message-chat-ai',
  new_chat_message_ai: 'new-chat-message-ai',
  send_message_multichat_ai: 'send-message-multichat-ai',
  send_message_individual_id: 'user-message-id'
};
